import { useEffect, useState } from "react";
import { IconClose, IconHamberger } from "../../Assets/Icons";
import { Link } from "react-router-dom";

interface NavbarProps {
  isMenuOpen: boolean;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const MENU_ITEMS = ["Beranda", "Tentang Kami", "Program", "Pendaftaran", "Galang Dana", "Region Check", "Berita"];
const NavbarThree: React.FC<NavbarProps> = ({ isMenuOpen, setIsMenuOpen }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed left-1/2 -translate-x-1/2 z-50 w-full
        rounded-3xl px-4 py-3 flex justify-between items-center font-montserrat
        transition-all duration-300
        ${isScrolled ? "bg-white/5 shadow-md backdrop-blur-md" : "bg-gray-100"}
      `}>
      {/* LOGO */}
      <Link to="/" className="flex items-center gap-2">
        <img src="/images/logo_peduli.png" alt="Logo" className="w-12 h-12 md:w-14 md:h-14" />
      </Link>

      {/* BREADCRUMB DESKTOP */}
      <nav className="hidden lg:flex gap-6 items-center">
        {MENU_ITEMS.map((item) => {
          return (
            <Link to={"/"}>
              <div
                key={item}
                className="cursor-pointer px-3 py-1 rounded-full transition-all duration-300
                 text-red-600 font-bold ">
                {item}
              </div>
            </Link>
          );
        })}
      </nav>

      {/* MOBILE TOGGLE */}
      <button className="lg:hidden z-50 text-black" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? "Close menu" : "Open menu"}>
        {isMenuOpen ? <IconClose /> : <IconHamberger />}
      </button>

      {/* MOBILE MENU (BREADCRUMB) */}
      <div
        className={`fixed top-0 left-0 w-full bg-white z-40 rounded-b-3xl
          transition-transform duration-300 ease-in-out
          ${isMenuOpen ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}
        `}>
        <div className="pt-24 pb-10 px-6 flex flex-col items-center gap-4 text-base font-medium text-gray-700">
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Beranda
          </Link>
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Tentang Kami
          </Link>
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Program
          </Link>
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Pendaftaran
          </Link>
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Galang Dana
          </Link>
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Region Check
          </Link>
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:text-red-500">
            Berita
          </Link>
        </div>
      </div>
    </header>
  );
};

export default NavbarThree;
